import { Fragment } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Typography } from "@material-ui/core";
import { RenderCellExpand } from "../../../../../../../shared/components";
import useStyles from "./styles";

export const FailedTablePolizas = ({ rows }) => {
  const classes = useStyles();

  const columns = [
    {
      field: "oficina",
      headerName: "Oficina",
      flex: 0.5,
      headerClassName: "header",
      headerAlign: "center",
    },
    {
      field: "ramo",
      headerName: "Ramo",
      flex: 0.5,
      headerClassName: "header",
      headerAlign: "center",
    },
    {
      field: "poliza",
      headerName: "Póliza",
      flex: 0.7,
      headerClassName: "header",
      headerAlign: "center",
    },
    {
      field: "error",
      headerName: "Error",
      flex: 2.5,
      headerClassName: "header",
      headerAlign: "center",
      renderCell: RenderCellExpand,
    },
  ];

  return (
    <Fragment>
      <Typography variant="h6" color="primary">
        Pólizas con error
      </Typography>
      <DataGrid
        columns={columns}
        rows={rows ?? []}
        className={classes.root}
        disableSelectionOnClick
        disableColumnMenu
        rowsPerPageOptions={[8]}
        pageSize={8}
        pagination
      />
    </Fragment>
  );
};
